export default __webpack_public_path__ + "static/media/ellipse-1.6f929745.svg";